// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"623":"36825be2","663":"fcdf28b7"}[chunkId] + ".css";
};